import React from "react";

export default function SettingsWebview({ url }: { url: string }) {
  return (
    <div>
      <iframe
        data-testid="webview-iframe"
        src={url}
        title="Settings Webview"
        className="w-full h-screen border-0 border-none"
      />
    </div>
  );
}
